import { createAction } from '@reduxjs/toolkit';

type SetSelectedUpgradeProductParameter = undefined | string;

type SetPDPEstimatedTotalParameter =
  | undefined
  | {
      totalPrice: {
        centAmount: number;
        currencyCode?: string;
        fractionDigits?: number;
      };
    };
export const setSelectedUpgradeProduct =
  createAction<SetSelectedUpgradeProductParameter>(
    'pdp/setSelectedUpgradeProduct',
  );

export const setPDPEstimatedTotal = createAction<SetPDPEstimatedTotalParameter>(
  'pdp/setPDPEstimatedTotal',
);

export const setSelectedBedFrameAOVSKUs = createAction<string[]>(
  'pdp/setSelectedBedFrameAOVSKUs',
);

export const setMattressAndFrameOption = createAction<{
  mattressAndFrameOption: string;
}>('pdp/setMattressAndFrameOption');
